import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withKeys as _withKeys, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "loginContainer" }
const _hoisted_2 = { class: "buttonContainer" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { style: {"align-items":"center"} }
const _hoisted_5 = {
  key: 0,
  style: {"margin":"10px","display":"flex","align-items":"center","justify-content":"center"}
}

import { UserActions, UserLoginMsg } from '@/store/modules/user';
import { ref, reactive } from 'vue';
import { useStore } from 'vuex';
import router from '@/router';
import QrcodeVue from 'qrcode.vue'
import { InfoFilled } from '@element-plus/icons-vue';
import { ElInput } from 'element-plus';


import { defineComponent } from 'vue';

const __default__ = defineComponent({
    name: "Login",
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore();
const isLoginMsg = ref<boolean>(false)
const loginForm: UserLoginMsg = reactive({
    username: "",
    password: "",
    otpCode: "",
});
const isOtpExist = ref<boolean>(false)
const secret = ref<string>("")
const inputName = ref<InstanceType<typeof ElInput>>()
const inputPwd = ref<InstanceType<typeof ElInput>>()
const inputOtpCode = ref<InstanceType<typeof ElInput>>()

const clickEnter = () => {
    inputName.value?.input?.blur()
    inputPwd.value?.input?.focus()
}

const onSubmit = async () => {
    try {
        const loginRes = await store.dispatch(`user/${UserActions.asyncCheckOtpExist}`, loginForm);
        isLoginMsg.value = true

        if (typeof loginRes === 'boolean' && loginRes == true) {
            isOtpExist.value = loginRes
        } else if (typeof loginRes === 'boolean' && loginRes == false) {
            isLoginMsg.value = false
            login()
        } else if (typeof loginRes === 'string' && loginRes !== '') {
            isOtpExist.value = false
            secret.value = 'otpauth://totp/' + loginForm.username + '?secret=' + loginRes
        } else {
            isLoginMsg.value = false
        }
    } catch (err) {
        console.log(err)
    }
}

const login = async () => {
    const loginRes = await store.dispatch(`user/${UserActions.login}`, loginForm);
    if (loginRes) {
        router.push("/");
    }
}


return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_text = _resolveComponent("el-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isLoginMsg.value)
      ? (_openBlock(), _createBlock(_component_el_form, {
          key: 0,
          class: "loginForm",
          model: loginForm,
          "label-position": "right",
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "用户名",
              prop: "username"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElInput), {
                  ref_key: "inputName",
                  ref: inputName,
                  modelValue: loginForm.username,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((loginForm.username) = $event)),
                  onKeydown: _withKeys(clickEnter, ["enter"])
                }, null, 8, ["modelValue", "onKeydown"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "密码",
              prop: "password"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElInput), {
                  ref_key: "inputPwd",
                  ref: inputPwd,
                  type: "password",
                  modelValue: loginForm.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((loginForm.password) = $event)),
                  onKeydown: _withKeys(onSubmit, ["enter"])
                }, null, 8, ["modelValue", "onKeydown"])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: onSubmit
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 登陆 ")
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["model"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (!isOtpExist.value)
              ? (_openBlock(), _createBlock(QrcodeVue, {
                  key: 0,
                  value: secret.value,
                  size: 200,
                  level: "H"
                }, null, 8, ["value"]))
              : _createCommentVNode("", true)
          ]),
          (!isOtpExist.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_el_icon, { size: 20 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(InfoFilled))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_text, null, {
                  default: _withCtx(() => [
                    _createTextVNode("请先扫描二维码绑定用户")
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form, {
            class: "loginContainer",
            model: loginForm,
            "label-position": "right",
            "label-width": "100px",
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "验证码",
                prop: "otpCode"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ElInput), {
                    ref_key: "inputOtpCode",
                    ref: inputOtpCode,
                    modelValue: loginForm.otpCode,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((loginForm.otpCode) = $event)),
                    onKeydown: _withKeys(login, ["enter"])
                  }, null, 8, ["modelValue", "onKeydown"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: login
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 确定 ")
            ]),
            _: 1
          })
        ]))
  ]))
}
}

})